"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactPlacesAutocomplete = _interopRequireDefault(require("react-places-autocomplete"));
var _Icons = _interopRequireDefault(require("./Icons"));
var _TooltipCoachmark = _interopRequireDefault(require("./TooltipCoachmark"));
var _excluded = ["placeholder", "label", "valid", "message", "className", "style", "id", "autoSelectOnFocus", "fieldStyle", "width", "onChange", "timeoutOptions", "customValue"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TextField = function TextField(props) {
  var _useState = (0, _react.useState)("fieldClass-" + Math.floor(Math.random() * 100000000)),
    _useState2 = _slicedToArray(_useState, 2),
    fieldClass = _useState2[0],
    setFieldClass = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (isFocused) {
      var _document$querySelect;
      (_document$querySelect = document.querySelector(".".concat(fieldClass))) === null || _document$querySelect === void 0 || _document$querySelect.focus();
    }
  }, [isFocused]);
  var placeholder = props.placeholder,
    label = props.label,
    valid = props.valid,
    message = props.message,
    className = props.className,
    style = props.style,
    id = props.id,
    autoSelectOnFocus = props.autoSelectOnFocus,
    fieldStyle = props.fieldStyle,
    width = props.width,
    onChange = props.onChange,
    timeoutOptions = props.timeoutOptions,
    customValue = props.customValue,
    rest = _objectWithoutProperties(props, _excluded);
  function onChangeHandler(e) {
    onChange(e);
    if (timeoutOptions) {
      var _e$currentTarget = e.currentTarget,
        name = _e$currentTarget.name,
        value = _e$currentTarget.value;
      var callback = timeoutOptions.callback ? timeoutOptions.callback : function () {};
      var time = timeoutOptions.time ? timeoutOptions.time : 1000;
      clearInterval(ref.current);
      ref.current = setTimeout(function () {
        callback(name, value);
      }, time);
    }
  }
  function focus(e) {
    setIsFocused(true);
  }
  if (props.autoSelectOnFocus) {
    rest.onFocus = function (event) {
      event.target.select();
    };
  }
  var classes = (0, _classnames["default"])("input-field", valid, props.fieldStyle, {
    "filled": props.value,
    "location": props.type === "location",
    "disabled": props.disabled,
    "showCustomValue": !isFocused && customValue
  }, className);
  // WARNING : Location type uses google places api, we need api key and the onChange Gives the value back only.

  var fieldClassToUse = customValue && !isFocused ? "customInput" : fieldClass;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "field-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style,
    id: id
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "field-placeholder"
  }, label), props.type === "location" && /*#__PURE__*/_react["default"].createElement(_reactPlacesAutocomplete["default"], {
    googleLogo: false,
    onSelect: function onSelect(e) {
      props.onChange(e, true);
    },
    inputProps: {
      tabIndex: props.tabIndex,
      value: props.value,
      onChange: onChange,
      placeholder: placeholder,
      autoComplete: props.autoComplete
    },
    classNames: {
      root: 'suggestive-field-container',
      input: (0, _classnames["default"])('suggestive-input', fieldClassToUse),
      autocompleteContainer: 'suggestions-list'
    }
  }), !["location", "area"].includes(props.type) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customValue && /*#__PURE__*/_react["default"].createElement("div", {
    onClick: focus,
    onBlur: function onBlur() {
      setIsFocused(false);
    }
  }, !isFocused && /*#__PURE__*/_react["default"].createElement("div", {
    className: "customInput"
  }, customValue), /*#__PURE__*/_react["default"].createElement("input", _extends({
    placeholder: placeholder,
    className: fieldClassToUse,
    style: {
      width: width
    },
    onChange: onChangeHandler
  }, rest))), !customValue && /*#__PURE__*/_react["default"].createElement("input", _extends({
    placeholder: placeholder,
    className: fieldClassToUse,
    style: {
      width: width
    },
    onChange: onChangeHandler
  }, rest))), props.fieldStyle === "text-field-dashed" && /*#__PURE__*/_react["default"].createElement("svg", {
    className: "svg-dashed {{ classes }}",
    height: "1px",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "0",
    y1: "1",
    x2: "400",
    y2: "1",
    stroke: "black"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "field-message ".concat(message ? "show" : "")
  }, message), valid === "error" && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    isControlled: true,
    type: "coachmark-icon",
    position: "right",
    context: ".".concat(fieldClassToUse),
    state: "show",
    color: "red"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-error",
    className: "the-svg-icons"
  })), valid === "empty" && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    isControlled: true,
    type: "coachmark-icon",
    position: "right",
    context: ".".concat(fieldClassToUse),
    state: "show",
    color: "grey"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow",
    className: "the-svg-icons"
  }))));
};
TextField.propTypes = {
  type: _propTypes["default"].oneOf(["text", "email", 'password', "url", "search", "tel", "location", "number"]),
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxLength: _propTypes["default"].number,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  valid: _propTypes["default"].oneOf(["valid", "error", 'disabled', 'empty', ""]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  required: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  autoSelectOnFocus: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  fieldStyle: _propTypes["default"].oneOf(["text-field-outline", "text-field-dashed", "text-field-boxed"]),
  autoComplete: _propTypes["default"].oneOf(['on', 'off', 'false', 'new-password']),
  width: _propTypes["default"].string,
  timeoutOptions: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    time: _propTypes["default"].number,
    callback: _propTypes["default"].func
  }), _propTypes["default"].bool]),
  customValue: _propTypes["default"].object
};
TextField.defaultProps = {
  type: "text",
  name: "",
  value: "",
  maxLength: 255,
  placeholder: null,
  valid: "",
  message: null,
  required: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  className: "",
  style: {},
  tabIndex: 1,
  id: null,
  fieldStyle: "text-field-outline",
  autoComplete: 'new-password',
  timeoutOptions: null,
  customValue: null
};
var _default = exports["default"] = TextField;